import { useEffect } from 'react'

import { mkassaApi } from 'redux/services/mkassa'
import { GetMkassaParams } from 'redux/services/mkassa/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetMkassaParams
}

function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = mkassaApi.useLazyStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}

export default Statistics
